import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../../types/store'
import {
    alertErrorMessage,
    throwSuccessMessage,
} from '../../../../utils/Errors'
import { fetchProductsGroups } from './fetchProductsGroups'
import { IProductGroup } from '../../../../types/product'
import { getUrlWithVersion } from '../../../../api/api'

export const dndProductBetweenGroups = createAsyncThunk<
    void,
    {
        sourceGroupId: string
        destinationGroupId: string
        productId: string
        reorderedGroups: IProductGroup[]
    },
    ThunkConfig<string>
>('productsSlice/dndProductBetweenGroups', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
        dispatch,
    } = thunkAPI

    const { sourceGroupId, destinationGroupId, productId, reorderedGroups } =
        args

    try {
        await api.delete(
            getUrlWithVersion(`/groups/${sourceGroupId}/entries/${productId}`)
        )

        await api.post(`/groups/${destinationGroupId}/entries`, {
            entries: [productId],
        })
        throwSuccessMessage('Success!')
    } catch (e) {
        alertErrorMessage(e)
        dispatch(fetchProductsGroups())
        return rejectWithValue('Failed to change product position')
    }
})
